/**
 * Smart search select box
 */
admin.registerLoad(function (prefix) {

    $(prefix + '.chosen-smart').each(function () {

        $(this).ajaxChosen({
            type: 'GET',
            url: $(this).data('url'),
            dataType: 'json'
        }, function (data) {
            var results = [];

            $.each(data.data, function (i, val) {
                results.push({ value: val.id, text: val.display });
            });

            return results;
        });
    });

});